import type { TranslationService } from '../services/translation.service';
import {
  OPTIONAL_CONSENTS,
  MANDATORY_CONSENTS,
  type Consent,
  type OptionalConsent,
  type MandatoryConsent,
} from '../models/consent.enum';

export interface ConsentCardData {
  title: string;
  description: string;
}

export type ConsentMapping = Record<Consent, ConsentCardData>;

export function isOptionalConsent(consent: string): consent is OptionalConsent {
  return OPTIONAL_CONSENTS.includes(consent.toLowerCase() as OptionalConsent);
}

export function isMandatoryConsent(consent: string): consent is MandatoryConsent {
  return MANDATORY_CONSENTS.includes(consent.toLowerCase() as MandatoryConsent);
}

export function getConsentMapping(translationService: TranslationService): ConsentMapping {
  const brandName = translationService.t().brandName;
  const loyaltyProgram = translationService.t().loyaltyProgram;

  return {
    advices_and_offers_sustainability: {
      title: 'Advies en aanbiedingen over verduurzaming',
      description: `Advies en aanbiedingen over verduurzaming, zoals zonnepanelen, warmtepompen en isolatie.`,
    },
    advices_and_offers_brand: {
      title: 'Advies en aanbiedingen over producten',
      description: `Advies en aanbiedingen over ${brandName} producten en diensten.`,
    },
    actionmail: {
      title: 'Actiemails',
      description: `Actiemails met speciale aanbiedingen en acties van ${brandName}.`,
    },
    newsletter: {
      title: 'Nieuwsbrief',
      description: `Nieuws over ${brandName}, tips om te besparen en ontwikkelingen in de markt.`,
    },
    thuisvoordeel: {
      title: loyaltyProgram,
      description: `Updates en aanbiedingen van ${brandName} ${loyaltyProgram}.`,
    },
    zaakvoordeel: {
      title: 'Zaakvoordeel',
      description: `Updates en aanbiedingen van ${brandName} Zaakvoordeel.`,
    },
    goedzitters: {
      title: loyaltyProgram,
      description: `Updates en aanbiedingen van ${brandName} ${loyaltyProgram}.`,
    },
    service_mailing: {
      title: 'Service e-mails',
      description: `Belangrijke service e-mails van ${brandName}, zoals facturen, meterstanden en storingen.`,
    },
  };
}
